import { Outlet } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";

const GroupsDashboard = () => {
  return (
    <Sidebar>
      <Outlet />
    </Sidebar>
  );
};
export default GroupsDashboard;
